import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import useGetModelo145ByID from 'services/record/Modelo145/useGetModelo145ByID';
import Modelo145 from './Modelo145';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialModelo145 = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode("token");
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetModelo145ByID, errorGetModelo145ByID, getModelo145ByID, loadingGetModelo145ByID, successGetModelo145ByID } = useGetModelo145ByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...payload, ExpedienteId: expedienteIdByOrigen } : payload);


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getModelo145ByID(userId, prestacionId, formId, (payload) => setData(dataUserWithExpedienteByOrigen(payload)));
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title={'Modelo 145'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetModelo145ByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <Modelo145 dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialModelo145